import { Form, Icon, Label } from 'semantic-ui-react'
import { suridataApi } from '../../services/api'
import { toast } from 'react-toastify'
import { useState } from 'react'
import { Button } from 'react-bootstrap'


export default function Logout() {
    return (
        <>
            {
                localStorage.getItem('token') && 
                <Label as='a' onClick={() => {
                    localStorage.removeItem('token')
                    localStorage.removeItem('email')
                    window.location.reload()
                }} >
                    <Icon name='sign out' />
                    Sair
                </Label>
            }
        </>
    )
}
